<form class="form-inline">
    <div class="form-group">
        <div class="input-group ">
            <input class="form-control" [placeholder]="placeholder" name="dp" [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker">
            <div class="input-group-append">
                <button class="btn btn-outline-warning" (click)="d.toggle()" type="button"> <i class="fa fa-calendar"></i></button>
            </div>
        </div>
    </div>
</form>